import styled from 'styled-components';

import { Z_INDEX } from '~/common/constants/z-index';

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  transition: opacity 200ms ease-in-out;
  z-index: ${Z_INDEX.MODAL};
  cursor: pointer;
`;

export const StyledDrawer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 530px;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral[950]};
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 200ms ease-in-out;
  z-index: ${Z_INDEX.MODAL + 1};
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 750px) {
    width: 100%;
  }
`;
